import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { styled } from "@mui/material/styles";

export const RootDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    alignItems: "flex-start",
  },
  "& .MuiDialog-paper": {
    padding: theme.spacing(2, 2, 0),
    borderBottom: `0.0625rem solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    height: theme.spacing(9),
    overflow: "visible",
    boxShadow: "none",
  },
  "& .MuiBackdrop-root": {
    backgroundColor: "transparent",
  },
}));

export const Content = styled(DialogContent)(() => ({
  padding: 0,
  backgroundColor: "transparent",
}));

export const SearchWrapper = styled("div")({
  width: "100%",
});
